import { externalTooltipHandler } from '@lune-fe/lune-components-lib'
import { LuneThemeNew } from '@lune-fe/lune-ui-lib'
import { abbreviateNumber } from 'js-abbreviation-number'

import { CarbonStorageOverTimeProps } from 'views/Projects/Project/CarbonStorageOverTime/Chart'

export interface Dataset {
    date: string
    quantity: string
    value: string
}

const { palette, typography } = LuneThemeNew

// Utils
export const chartColors = {
    buffer: palette.Data800,
    assumedLeakage: palette.Data700,
    creditsIssued: palette.Data500,
    carbonStock: palette.Grey900,
    baseline: palette.Data100,
}

// Chart options
export const chartOptions = (chartData: CarbonStorageOverTimeProps[]) => {
    return {
        maintainAspectRatio: false,
        elements: {
            point: {
                pointBorderColor: 'white',
                pointBorderWidth: '2',
                radius: 4,
            },
        },
        layout: {
            autoPadding: false,
            padding: {
                left: -20,
            },
        },
        scales: {
            y: {
                grid: {
                    tickLength: 0,
                    drawBorder: false,
                    color: [palette.Grey250],
                    tickBorderDashOffset: 0,
                },
                ticks: {
                    mirror: true,
                    z: 9 as const,
                    padding: 10 as const,
                    showLabelBackdrop: true,
                    backdropColor: palette.White,
                    backdropPadding: 4,
                    textStrokeWidth: 10,
                    color: palette.Grey900,
                    font: {
                        family: typography.fontFamily,
                    },
                    callback: (value: any, index: number, ticks: any) => {
                        if (index === 0 || index === ticks.length - 1) {
                            return null
                        } else {
                            return abbreviateNumber(value)
                        }
                    },
                },
            },
            x: {
                stacked: true,
                ticks: {
                    beginAtZero: true,
                    font: {
                        family: typography.fontFamily,
                    },
                    color: palette.Grey900,
                },
                grid: {
                    tickLength: 10,
                    tickColor: palette.White,
                    drawBorder: false,
                    color: [palette.Grey250],
                },
            },
        },
        plugins: {
            paddingBelowLegends: '30px',
            legend: {
                display: false,
            },
            tooltip: {
                enabled: false,
                position: 'nearest' as const,
                external: (context: any) =>
                    externalTooltipHandler(context, {
                        isCarbonStorage: true,
                        carbonStorageOverTimeData: chartData,
                    }),
            },
            chartAreaBorder: {
                borderColor: palette.Grey250,
                borderWidth: 1,
            },
        },
    }
}
